import { render, staticRenderFns } from "./app_dialog.vue?vue&type=template&id=482797f8&scoped=true"
import script from "./app_dialog.vue?vue&type=script&lang=js"
export * from "./app_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482797f8",
  null
  
)

export default component.exports